var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 50,
    viewBox: "0 0 32 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 3.125C25.8288 3.125 26.6237 3.45424 27.2097 4.04029C27.7958 4.62634 28.125 5.4212 28.125 6.25V43.75C28.125 44.5788 27.7958 45.3737 27.2097 45.9597C26.6237 46.5458 25.8288 46.875 25 46.875H6.25C5.4212 46.875 4.62634 46.5458 4.04029 45.9597C3.45424 45.3737 3.125 44.5788 3.125 43.75V6.25C3.125 5.4212 3.45424 4.62634 4.04029 4.04029C4.62634 3.45424 5.4212 3.125 6.25 3.125H25ZM6.25 0C4.5924 0 3.00268 0.65848 1.83058 1.83058C0.65848 3.00269 0 4.5924 0 6.25V43.75C0 45.4076 0.65848 46.9973 1.83058 48.1694C3.00268 49.3415 4.5924 50 6.25 50H25C26.6576 50 28.2473 49.3415 29.4194 48.1694C30.5915 46.9973 31.25 45.4076 31.25 43.75V6.25C31.25 4.5924 30.5915 3.00269 29.4194 1.83058C28.2473 0.65848 26.6576 0 25 0L6.25 0Z",
    fill: "url(#paint0_linear_79_1176)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_1176",
    x1: 15.625,
    y1: 0,
    x2: 15.625,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EF9C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EF9C3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.497c46d5b5b55de94e2801f272711539.svg";
export { ForwardRef as ReactComponent };